import {Modal} from "react-bootstrap";
import {Link} from "react-router-dom";
import React from "react";
import {FiArrowRight, FiCheck, FiClock, FiFileText, FiMapPin, FiUsers, FiX} from "react-icons/fi";

const styles = {
    modal: {
        borderRadius: 10,
        border: 'none',
        overflow: 'hidden',
        boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
    },
    header: {
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
        border: 'none',
        padding: '20px 24px 16px',
    },
    title: {
        color: '#fff',
        fontSize: '1rem',
        fontWeight: 600,
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        margin: 0,
    },
    teamBadge: {
        display: 'inline-block',
        background: 'rgba(255,255,255,0.12)',
        color: '#a8c0e8',
        fontSize: '0.7rem',
        fontWeight: 600,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        padding: '3px 10px',
        borderRadius: '20px',
        marginTop: '6px',
    },
    body: {
        padding: '0',
        background: '#fff',
    },
    infoSection: {
        padding: '20px 24px 16px',
        borderBottom: '1px solid #f0f2f5',
    },
    locationRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '10px',
    },
    locationText: {
        fontSize: '1.1rem',
        fontWeight: 700,
        color: '#1a1a2e',
        margin: 0,
    },
    timeRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        color: '#6b7280',
        fontSize: '0.85rem',
        marginBottom: '4px',
    },
    divider: {
        color: '#d1d5db',
        margin: '0 4px',
    },
    descriptionRow: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: '8px',
        marginTop: '10px',
        padding: '10px 12px',
        background: '#f8f9fb',
        borderRadius: '8px',
        fontSize: '0.85rem',
        color: '#4b5563',
    },
    linkSection: {
        padding: '12px 24px',
        borderBottom: '1px solid #f0f2f5',
    },
    detailLink: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        fontSize: '0.82rem',
        fontWeight: 600,
        color: '#3b6fd4',
        textDecoration: 'none',
        letterSpacing: '0.02em',
    },
    invitationsSection: {
        padding: '16px 24px 20px',
    },
    invitationsHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '12px',
    },
    invitationsTitle: {
        fontSize: '0.72rem',
        fontWeight: 700,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        color: '#9ca3af',
        margin: 0,
    },
    invitationsCount: {
        fontSize: '0.72rem',
        fontWeight: 700,
        background: '#f0f2f5',
        color: '#6b7280',
        padding: '2px 7px',
        borderRadius: '10px',
    },
    invitationsList: {
        maxHeight: '180px',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
    },
    invitationRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '7px 10px',
        borderRadius: '8px',
        background: '#f8f9fb',
    },
    invitationName: {
        fontSize: '0.85rem',
        fontWeight: 500,
        color: '#374151',
    },
    presentBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '3px',
        fontSize: '0.72rem',
        fontWeight: 600,
        color: '#16a34a',
        background: '#dcfce7',
        padding: '2px 8px',
        borderRadius: '20px',
    },
    absentBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '3px',
        fontSize: '0.72rem',
        fontWeight: 600,
        color: '#dc2626',
        background: '#fee2e2',
        padding: '2px 8px',
        borderRadius: '20px',
    },
    footer: {
        border: 'none',
        padding: '12px 24px 16px',
        background: '#fff',
    },
    closeBtn: {
        fontSize: '0.82rem',
        fontWeight: 600,
        padding: '7px 20px',
        borderRadius: '8px',
        border: '1px solid #e5e7eb',
        background: '#fff',
        color: '#6b7280',
        cursor: 'pointer',
    },
};

const ModalCalendarTrainingDetail = (props) => {
    console.log('DEttaglio', props.eventDetail && props.eventDetail.id, props.eventDetail)
    const id = props.eventDetail?.id;
    const invitations = props.eventDetail?.invitations || [];

    return (
        <Modal show={props.showModalDetail} onHide={props.handleCloseModal} aria-labelledby="modal-title" centered>
            <div style={styles.modal}>
                {/* Header */}
                <div style={styles.header}>
                    <button
                        onClick={props.handleCloseModal}
                        style={{
                            position: 'absolute',
                            top: '14px',
                            right: '16px',
                            background: 'none',
                            border: 'none',
                            color: 'rgba(255,255,255,0.5)',
                            fontSize: '1.2rem',
                            cursor: 'pointer',
                            lineHeight: 1
                        }}
                    >
                        ×
                    </button>
                    <p style={styles.title}>Dettagli allenamento</p>
                    {props.eventDetail?.team_name && (
                        <span style={styles.teamBadge}>{props.eventDetail.team_name}</span>
                    )}
                </div>

                {/* Info */}
                <div style={styles.infoSection}>
                    <div style={styles.locationRow}>
                        <FiMapPin size={15} color="#3b6fd4"/>
                        <p style={styles.locationText}>{props.eventDetail?.title || 'Nessun luogo'}</p>
                    </div>
                    <div style={styles.timeRow}>
                        <FiClock size={13}/>
                        <span>{props.eventDetail?.start}</span>
                        <span style={styles.divider}>→</span>
                        <span>{props.eventDetail?.end}</span>
                    </div>
                    {props.eventDetail?.description && (
                        <div style={styles.descriptionRow}>
                            <FiFileText size={13} style={{marginTop: '2px', flexShrink: 0}}/>
                            <span>{props.eventDetail.description}</span>
                        </div>
                    )}
                </div>

                {/* Link */}
                <div style={styles.linkSection}>
                    <Link to={'/allenamenti/dettaglio-allenamento/' + id} style={styles.detailLink}>
                        Vai al dettaglio completo <FiArrowRight size={12}/>
                    </Link>
                </div>

                {/* Invitations */}
                {invitations.length > 0 && (
                    <div style={styles.invitationsSection}>
                        <div style={styles.invitationsHeader}>
                            <FiUsers size={13} color="#9ca3af"/>
                            <span style={styles.invitationsTitle}>Convocati</span>
                            <span style={styles.invitationsCount}>{invitations.length}</span>
                        </div>
                        <div style={styles.invitationsList}>
                            {invitations.map(inv => (
                                <div key={inv.invitation_id} style={styles.invitationRow}>
                                    <span style={styles.invitationName}>{inv.profile_name}</span>
                                    {inv.accepted === 'Yes' ? (
                                        <span style={styles.presentBadge}><FiCheck size={10}/> Presente</span>
                                    ) : (
                                        <span style={styles.absentBadge}><FiX size={10}/> Non ha risposto</span>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* Footer */}
                <div style={styles.footer}>
                    <button style={styles.closeBtn} onClick={props.handleCloseModal}>Chiudi</button>
                </div>
            </div>
        </Modal>
    );
};

export default ModalCalendarTrainingDetail;
